import React from "react";
import cancel from "../../assets/cancelSvg.svg";
import Modal from "react-bootstrap/Modal";
import "./findDealer.css";
import ButtonComponent from "../Button/Button";
import { Form } from "react-bootstrap";
import Search from "../../assets/Search.svg";
const FindDealer = ({ show, setShow, title, onChange, onSearch, children,handleClose }) => {

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch();
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="dealer-modal"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
        <div onClick={handleClose} className="cancel-modal">
          <img src={cancel} alt="Cancel" />
        </div>
      </Modal.Header>
      <div className="modal-body-section">
        <Form.Group controlId="searchBar" className="searchBar">
          <Form.Control
            type="text"
            placeholder="Enter location, City, State or ZIP code"
            className="findDealer-SearchBar"
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <div className="search-icon">
            <img src={Search} alt="Search" />
          </div>
        </Form.Group>
        <ButtonComponent
          buttonText="Find Dealer"
          variant="rounded"
          onClick={onSearch}
        />
      </div>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default FindDealer;
